module.exports = "pegasus/assets/icn_5.png";